import { IMemberOrganisationCard } from '../interfaces/iMemberOrganisationCard';
import { ICause } from '../interfaces/iCause';
import { IOrganization } from '../interfaces/iOrganization';

export class MemberOrganisationCard implements IMemberOrganisationCard {
	key: string;
	name: string;
	role: string;
	causes: ICause[];
	company: string;
	imgUrl: string;
	organisations: IOrganization[];
	memberOrgKey: string;

	constructor(memberOrganisationCard: IMemberOrganisationCard = {} as IMemberOrganisationCard) {
		this.key = memberOrganisationCard.key;
		this.name = memberOrganisationCard.name;
		this.role = memberOrganisationCard.role;
		this.causes = memberOrganisationCard.causes;
		this.company = memberOrganisationCard.company;
		this.imgUrl = memberOrganisationCard.imgUrl;
		this.organisations = memberOrganisationCard.organisations;
		this.memberOrgKey = memberOrganisationCard.memberOrgKey;
	}
}



// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/memberOrganisationCard.ts